export default __webpack_public_path__ + "static/media/headerLogo.f69a3415.svg";